import React from 'react';
import PropTypes from 'prop-types';
import PaperclipIcon from 'mdi-react/PaperclipIcon';
import TrashCanIcon from 'mdi-react/TrashCanIcon';
import { UploadOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import {
  Row, Col, Tooltip, Input, Select, Button, Upload, Spin, Form,
} from 'antd';
import { formatBP } from '../../../utils/format';
import './ImportShapefiles.scss';

const ImportShapefilesFirstStage = (props): JSX.Element => {
  const {
    matriculation,
    land,
    landOptions,
    allFiles,
    renderFileName,
    errorShapefiles,
    validatingMatriculation,
    removeFile,
    changeUpload,
    handleMatriculation,
    handleLand,
  } = props;

  const getItemIcon = (statuss): JSX.Element | null => {
    switch (statuss) {
      case 'success':
        return <CheckCircleOutlined style={{ color: 'green' }} />;

      case 'error':
        return <CloseCircleOutlined style={{ color: 'red' }} />;

      default:
        return null;
    }
  };

  return (
    <div className="first-col">
      <Row>
        <Col
          xs={{ span: 24 }}
        >
          <Form.Item
            label="BP"
            labelCol={{ span: 24 }}
            required
            validateStatus={matriculation.error ? 'error' : ''}
            help={matriculation.errorMessage}
          >
            <Input
              value={matriculation.value}
              onChange={
                (text): void => {
                  handleMatriculation(text.target.value);
                }
              }
              suffix={
                !validatingMatriculation ? (
                  getItemIcon(matriculation.status)
                ) : (
                  <Spin />
                )
              }
              onBlur={
                (eventt): void => {
                  handleMatriculation(eventt.target.value.replace(/.*/, formatBP(eventt.target.value)));
                }
              }
              type="number"
              placeholder="BP com 10 dígitos"
              maxLength={10}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
        >
          <Form.Item
            label="Propriedade"
            labelCol={{ span: 24 }}
            required
            validateStatus={land.error ? 'error' : ''}
            help={land.errorMessage}
          >
            <Select
              showSearch
              value={land.value || undefined}
              placeholder="Selecione a propriedade"
              loading={validatingMatriculation}
              onChange={handleLand}
            >
              {
                landOptions.map(
                  (element) => (
                    <Select.Option key={`${element.id}${element.name}`} value={`::${element.id}::${element.name}`}>
                      {element.name}
                    </Select.Option>
                  ),
                )
              }
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
        >
          <Form.Item
            label="Importar Talhões"
            labelCol={{ span: 24 }}
            required
          >
            <Upload
              accept=".rar,.zip,application/zip,application/rar,.kml,.KML,.kmz,.KMZ,application/vnd.google-earth.kmz"
              method="get"
              multiple
              onChange={changeUpload}
              fileList={allFiles}
            >
              <Button
                style={{
                  width: '100%',
                  borderColor: errorShapefiles ? '#f5222d' : '#d9d9d9',
                }}
              >
                <UploadOutlined />
                Carregar arquivos
              </Button>
            </Upload>
            {
              errorShapefiles && (
                <span style={{ color: '#f5222d' }}>Informe o(s) arquivo(s)</span>
              )
            }
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col
          xs={{ span: 24 }}
        >
          {
            allFiles.map((element) => (
              <div key={element.name} className="shape-list">
                <PaperclipIcon />
                <div className="shape-list-info">
                  <Tooltip title={element.name}>
                    <span>{renderFileName(element.name)}</span>
                  </Tooltip>
                  <Tooltip title="remover">
                    <Button
                      icon={<TrashCanIcon />}
                      onClick={
                        (): void => {
                          removeFile(element);
                        }
                      }
                      type="link"
                    />
                  </Tooltip>
                </div>
              </div>
            ))
          }
        </Col>
      </Row>
    </div>
  );
};

ImportShapefilesFirstStage.propTypes = {
  matriculation: PropTypes.shape({
    value: PropTypes.string.isRequired,
    error: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,

  land: PropTypes.shape({
    value: PropTypes.string.isRequired,
    error: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
  }).isRequired,

  landOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  allFiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  errorShapefiles: PropTypes.bool.isRequired,
  validatingMatriculation: PropTypes.bool.isRequired,
  renderFileName: PropTypes.func.isRequired,
  removeFile: PropTypes.func.isRequired,
  changeUpload: PropTypes.func.isRequired,
  handleMatriculation: PropTypes.func.isRequired,
  handleLand: PropTypes.func.isRequired,
};

ImportShapefilesFirstStage.defaultProps = {};

export default ImportShapefilesFirstStage;
